var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dados-local"},[_c('Card',{attrs:{"title":"Dados do Local"}},[_c('lista-component',{attrs:{"headers":_vm.headers,"items":_vm.analise}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }